import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useCallLogView, CallLogData } from './hooks';
import {
  CallLogHeader,
  CallInfoSection,
  CallNotesSection
} from './components';

interface ViewCallLogDialogProps {
  open: boolean;
  onClose: () => void;
  callLog: CallLogData | null;
}

const ViewCallLogDialog: React.FC<ViewCallLogDialogProps> = ({
  open,
  onClose,
  callLog
}) => {
  const { callDate, formatDate, formatTime, formatFullDate } = useCallLogView(callLog);

  if (!callLog) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
        }
      }}
    >
      <DialogTitle
        sx={{
          pb: 1,
          borderBottom: '1px solid #e2e8f0',
          backgroundColor: '#f8fafc'
        }}
      >
        <CallLogHeader
          isCallAnswered={callLog.isCallAnswered}
          fullDate={formatFullDate(callDate)}
        />
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={3}>
          <CallInfoSection
            formattedDate={formatDate(callDate)}
            formattedTime={formatTime(callDate)}
            callBy={callLog.callBy}
            callTo={callLog.callTo}
          />

          <CallNotesSection notes={callLog.notes} />
        </Stack>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          pt: 2,
          borderTop: '1px solid #e2e8f0',
          backgroundColor: '#f8fafc'
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          startIcon={<Close />}
          sx={{
            color: '#64748b',
            borderColor: '#d1d5db',
            '&:hover': {
              backgroundColor: '#f1f5f9',
              borderColor: '#9ca3af'
            }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewCallLogDialog;
